import(/* webpackMode: "eager", webpackExports: ["LeagueDetailsWrapper"] */ "/app/apps/pickleball/src/app/(default)/(leagues)/leagues/[slug]/session/[sessionId]/LeagueDetailsWrapper.tsx");
